<template>
  <div>
    <div class="card">
      <DataTable 
        :loading="loading"
        :value="videosData" 
        rowGroupMode="rowspan" 
        groupRowsBy="section"
        sortMode="single" 
        sortField="section" 
        :sortOrder="1" 
        scrollable 
        scrollHeight="400px"
        :filters="{ global: searchText }"
      >
        <Column 
          field="section" 
          header="Section"
          headerStyle="width: 9em"
        ></Column>
        <Column 
          field="videoTitle" 
          header="Title"
          headerStyle="width: 20em"
        >
          <template #body="slotProps">
            <div class="under_lined" style="width: 10em" @click="$emit('openVideo', slotProps.data)">
              {{ slotProps.data.videoTitle }}
            </div>
          </template>
        </Column>
        <Column 
          field="length" 
          header="Duration"
          headerStyle="width: 7em"
        >
          <template #body="slotProps">
            {{ (slotProps.data.length / 60).toFixed(2) }}mins
          </template>
        </Column>
        <Column 
          header="Thumbnail"
          headerStyle="width: 9em"
        >
          <template #body="slotProps">
            <img :src="getThumbnail(slotProps.data.url)" :alt="slotProps.data.videoTitle" class="product-image" />
          </template>
        </Column>
        <Column 
          field="author" 
          header="Author"
          headerStyle="width: 8em"
        ></Column>
        <Column 
          field="tags" 
          header="Tags"
          headerStyle="width: 12em"
        ></Column>
        <Column 
          field="dateAdded" 
          header="Date Added"
          headerStyle="width: 7em"
        >
          <template #body="slotProps">
            {{ (slotProps.data.dateAdded).substr(0, 10) }}
          </template>
        </Column>
        <Column 
          field="description" 
          header="Description"
          headerStyle="width: 0em; display: none;"
          bodyStyle="width: 0em; display: none;"
        ></Column>

      </DataTable>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchText: {
      type: String,
      required: false
    },
    videosData: {
      type: Array,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    getThumbnail(url) {
      if (url && url.length >= 8) {
        return `http://img.youtube.com/vi/${url.substr(8)}/1.jpg`
      } else {
        return ''
      }
    }
  }
}
</script>

<style>

</style>